export default __webpack_public_path__ + "static/media/door-knocking.8bc74a0a.ogg";